__turbopack_context__.v({
  "appBar": "T8HcSG_appBar",
  "header": "T8HcSG_header",
  "link": "T8HcSG_link",
  "menuLink": "T8HcSG_menuLink",
});
